export default __webpack_public_path__ + "static/media/312.54529fc9.png";